export default "__VITE_PUBLIC_ASSET__baa6beef__"